<template>
  <div class="bg_white boxs2 pl16 pr16 pt15 pb16">
    <h2 class="page_title ab c5a">口座情報の登録・変更（WEB）</h2>
    <div class="mt20 c5a">
      <p>口座登録については、三菱UFJファクター株式会社の「ネット口座振替受付サービス（WEB方式・SMS版）」を利用いたします。</p>
      <p class="mt10">使用されるスマートフォンへSMS（ショートメッセージサービス）にて、口座登録用URLを送信させていただきますので、SMSが受信可能であることを事前にご確認の上、お手続きをお願いいたします。</p>
      <p class="mt10">※専用コードは「<span class="rb red">NP123</span>」をご入力ください。</p>
      <p class="mt10">※法人登録の方は、WEB申込はご利用いただけませんので、前の画面に戻って「書面で申し込む」をご選択ください。</p>
      <p class="mt10 red">※ご登録いただいた口座情報がCONPUSに反映されるまで数日かかりますのであらかじめご了承ください。</p>
    </div>
    <div class="btn_wrap mt32">
      <button class="btn_yellow" type="button" @click="openExternal">申し込む</button>
    </div>
    <div class="mt16">
      <button class="btn_delete" type="button" @click="goBackOneStep">戻る</button>
    </div>
    <div class="mt20 c5a">
      <p class="mt10">
        <a href="#" @click.prevent="openGuide" class="text_link">お手続き方法のご案内</a>
      </p>
      <p class="mt10">
        <a href="#" @click.prevent="openBankList" class="text_link">ご利用いただける金融機関一覧</a>
      </p>
    </div>
  </div>
</template>

<script>
import openExternal from '@/model/openExternalBrowser'
export default {
  name: 'MemberBankAccountUseWeb',
  data() {
    return {
      // 提示された外部サービスURL（外部ブラウザで開く）
      externalUrl: 'https://muf-webkoufuri.net/plus/MUFGWCN080190Action_doInit.action?Yz0wOTY5MQ%3D%3D',
      guideUrl: 'https://www.naturally-plus.com/export2/shared/jp/ja/docs/media_center/Automatic_payment_web_manual_2603.pdf',
      bankListUrl: 'https://www.muf.bk.mufg.jp/collect/net/bank/',
    }
  },
  methods: {
    openExternal() {
      openExternal.open(this.externalUrl);
    },
    openGuide() {
      openExternal.open(this.guideUrl, { appendOpenExternalParam: true });
    },
    openBankList() {
      openExternal.open(this.bankListUrl, { appendOpenExternalParam: true });
    },
    goBackOneStep() {
      if (window.history && window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'MemberBankAccountUse' });
      }
    }
  }
}
</script>

<style scoped>
.btn_wrap {
  margin-top: 24px;
}
.red {
  color: #ff0000;
}
.small {
  font-size: 12px;
}
.text_link {
  color: #007AFF;
  text-decoration: underline;
}
.red {
  color: #ff0000;
}
</style>




// WEBPACK FOOTER //
// src/views/member/bankAccount/UseWeb.vue